<ng-container *ngIf="isDataSetLoaded$ | async; else loading">
<div class="animated fadeIn trafficDetail" style="margin-top: 68px">
  <div class="bs-container-fluid">
    <div class="flex-container flex-billboard-container">
      <scorecard-billboard-element
        *ngFor="let item of items"
        [settings]="item.settings"
        [dataSets]="dataSets$ | async"
        [viewContext]="viewContext"
        class="bs-col-md-6 flex-billboard-card-50"
      >
      </scorecard-billboard-element>
    </div>
  </div>
</div>
</ng-container>

<!-- Loading View with Pulse Animations -->
<ng-template #loading>
  <div class="animated fadeIn trafficDetail" style="margin-top: 68px">
    <div class="bs-container-fluid">
      <div class="flex-container flex-billboard-container">
        <mat-card appearance="outlined" *ngFor="let item of [0, 1, 2, 3]; let i = index">
        <mat-card-title>
            <div class="title-placeholder" syncPulse
                style="height: 24px; width: 150px; background-color: #e0e0e0; border-radius: 4px;"></div>
        </mat-card-title>
        <mat-card-content class="card-block target-card billboard" style="margin-bottom: 0px;">
            <div class="bs-flex-row" fxLayout="row">
                <div class="metric-container full-width-on-small">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <b class="metric-value">
                                        <span class="value-placeholder" syncPulse
                                            style="display: inline-block; width: 60%; height: 40px; background-color: #e0e0e0; border-radius: 4px;"></span>
                                    </b>
                                    <span class="icon-placeholder" syncPulse
                                        style="display: inline-block; width: 24px; height: 24px; background-color: #e0e0e0; border-radius: 50%; margin-left: 10px;"></span>
                                </td>
                            </tr>
                            <tr>
                                <td class="box-label" style="font-size: 1.2rem;">
                                    <span class="subtitle-placeholder" syncPulse
                                        style="display: inline-block; width: 50%; height: 20px; background-color: #e0e0e0; border-radius: 4px;"></span>
                                </td>
                            </tr>
                            <tr>
                                <td class="box-label" style="font-size: 1.2rem;">
                                    <span class="subtitle-placeholder" syncPulse
                                        style="display: inline-block; width: 60%; height: 20px; background-color: #e0e0e0; border-radius: 4px;"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="chart-container">
                    <div class="chart-placeholder" syncPulse style="height: 130px; background-color: #e0e0e0; border-radius: 8px;"></div>
                </div>
            </div>
        </mat-card-content>
        <mat-card-footer class="billboard-seperator">
            <table style="width: 100%">
                <tbody>
                    <tr>
                        <td style="width: 50%">
                            <span class="footer-placeholder" syncPulse
                                style="display: inline-block; width: 60%; height: 20px; background-color: #e0e0e0; border-radius: 4px;"></span>
                        </td>
                        <td style="width: 50%; text-align: right">
                            <span class="footer-placeholder" syncPulse
                                style="display: inline-block; width: 60%; height: 20px; background-color: #e0e0e0; border-radius: 4px;"></span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </mat-card-footer>
        </mat-card>

        
      </div>
    </div>
  </div>
</ng-template>


